import { Card, CardContent, CardHeader, Grid, CircularProgress, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Button, Tooltip, Typography } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import PropTypes, { object } from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router';
import Select, { components } from 'react-select';
import cn from 'classnames';
import styles from '../ClientPriceOverrides/ClientPriceOverrides.styles';
import { AppContext } from '../../AppContext';
import SearchIcon from '@material-ui/icons/Search';
import Error from '@material-ui/icons/Error';
import ColoredCheckbox from '../ColoredInputs/ColoredCheckbox';
import InfoTooltip from '../InfoTooltip';
import { ConfirmationDialog } from '../ConfirmationDialog';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import { getProducts, getSupplements, putPayable } from '../../services/payable.service';
import { FieldRepOrdersGrid } from '../Orders';
const useStyles = makeStyles({
  confirmationModal: {
    width: '90vw',
  },
});

const INPUT_ROW_HEIGHT = 35;

const formInputs = [
  {
    field: 'qaPayable',
    label: 'QA Payable',
  },
  {
    field: 'frPayable',
    label: 'Field Rep Payable',
  },
];

const supplementFormInput = [
  {
    field: 'qaPayable',
    label: 'QA Payable',
  },
  {
    field: 'frPayable',
    label: 'Field Rep Payable',
  },
];

// track the count of selected options from the <Autocomplete>
let counter = 0;
const ValueContainer = React.memo(({ children, getValue, ...props }) => {
  counter = getValue().length + ' selected';

  return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
});

const FieldRepQAPrice = ({ classes }) => {
  /**
   * STATE
   * */
  const [products, setProducts] = useState([]);
  const [supplements, setSupplements] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [supplementData, setSupplementData] = useState([]);

  // loading
  const [productsLoading, setProductsLoading] = useState(false);
  const [formIsSaving, setFormIsSaving] = useState(false);

  // selected variables
  const [selectedPropertyTypeId, setSelectedPropertyTypeId] = useState(null);
  const [selectedProductCategoryId, setSelectedProductCategoryId] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedSupplementName, setSelectedSupplementName] = useState(null);
  const [selectedFormHeaderId, setSelectedFormHeaderId] = useState(null);

  let [errorType, setErrorType] = useState([]);
  let [errorCategory, setErrorCategory] = useState([]);
  let [errorName, setErrorName] = useState([]);

  const [filteredNameColumnData, setFilteredNameColumnData] = useState([]);
  const [filteredSupplementData, setFilteredSupplementData] = useState([]);
  const [filteredCategoryColumnData, setFilteredCategoryColumnData] = useState([]);
  const [filteredCategorySupplementData, setFilteredCategorySupplementData] = useState([]);

  // control whether the form is in selected products only mode
  //   const [selectProduct, setSelectProduct] = useState(true);

  // control whether client is looking at supplements or products
  const [supplementView, setSupplementView] = useState(false);

  // track modified answer values for the current question
  const [validProductIds, setValidProductIds] = useState(new Set());
  const [validFormHeaderIds, setValidFormHeaderIds] = useState(new Set());

  // control the save changes modal
  const [showSaveChangesModal, setSaveChangesModal] = useState(false);
  const [changes, setChanges] = useState({});

  const [modifiedProducts, setModifiedProducts] = useState([]);
  const [modifiedSupplements, setModifiedSupplements] = useState([]);

  /**
   * API
   */
  // PayableAmounts/Products
  const getProductsData = async () => {
    setProductsLoading(true);
    const response = await getProducts();
    setProductsLoading(false);
    setProducts(response);
  };

  // PayableAmounts/Supplements
  const getSupplementsData = async () => {
    const response = await getSupplements();
    setSupplements(response);
  };

  // PayableAmounts
  const putPayableData = async payload => {
    const response = await putPayable(payload);
    return response;
  };

  /**
   * COMPUTED
   */
  const formIsReady = true;
  const formIsLoading = productsLoading;

  const { dispatch } = useContext(AppContext);

  /**
   * FUNCTIONS
   * */
  const createSupplementData = () => {
    console.log(supplements);
    const formattedSupplementData = supplements.reduce((acc, cur) => {
      if (!acc[cur.propertyTypeId]) acc[cur.propertyTypeId] = {};

      if (!acc[cur.propertyTypeId][cur.formHeaderId]) acc[cur.propertyTypeId][cur.formHeaderId] = [];

      acc[cur.propertyTypeId][cur.formHeaderId].push(cur);
      return acc;
    }, {});
    console.log(formattedSupplementData);
    setSupplementData(formattedSupplementData);
    setFilteredCategorySupplementData(formattedSupplementData);
    setFilteredSupplementData(formattedSupplementData);
  };

  const createColumnData = () => {
    // generate column data
    const formattedColumnData = products.reduce((acc, cur) => {
      if (!acc[cur.propertyTypeName]) acc[cur.propertyTypeName] = {};

      if (!acc[cur.propertyTypeName][cur.productCategoryName]) acc[cur.propertyTypeName][cur.productCategoryName] = [];

      acc[cur.propertyTypeName][cur.productCategoryName].push(cur);

      return acc;
    }, {});
    setColumnData(formattedColumnData);
    setFilteredCategoryColumnData(formattedColumnData);
    setFilteredNameColumnData(formattedColumnData);
  };

  const flattenSupplementData = () => {
    const flattened = Object.keys(supplementData)
      .map(propertyTypeName => {
        return Object.keys(supplementData[propertyTypeName]).map(
          supplementName => supplementData[propertyTypeName][supplementName],
        );
      })
      .flat()
      .flat();

    return flattened;
  };

  const flattenColumnData = () => {
    const flattened = Object.keys(columnData)
      .map(propertyTypeName => {
        return Object.keys(columnData[propertyTypeName]).map(
          productCategoryName => columnData[propertyTypeName][productCategoryName],
        );
      })
      .flat()
      .flat();

    return flattened;
  };

  const handleSaveChangesButton = () => {
    setSaveChangesModal(true);
    const flattenedColumnData = flattenColumnData();
    const flattenedSupplementData = flattenSupplementData();

    const modifiedColumnData = flattenedColumnData.filter(x => modifiedProducts.includes(x.productId));
    const modifiedSupplementData = flattenedSupplementData.filter(x => modifiedSupplements.includes(x.formHeaderId));

    const payload = { product: modifiedColumnData, supplement: modifiedSupplementData };

    // save changes
    //putPayableData(payload);
    setChanges(payload);
  };

  const saveOverridesAsync = async () => {
    try {
      setFormIsSaving(true);
      putPayableData(changes);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Pricing saved successfully!',
        },
      });
    } catch (error) {
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: typeof error === 'string' ? error : error.message || 'Pricing failed to save...',
        },
      });
    }

    setSaveChangesModal(false);
    setFormIsSaving(false);

    // clear modified products/supplements and changes
    setModifiedProducts([]);
    setModifiedSupplements([]);
    setChanges({});
  };

  const addProductToModifiedList = productId => {
    setValidProductIds(validProductIds.add(productId));
  };

  const toggleSupplementView = evt => {
    const newStatus = evt.target.checked;
    setSupplementView(newStatus);

    setSelectedPropertyTypeId(null);
    setSelectedProductCategoryId(null);
    setSelectedProductId(null);
  };

  const handleSupplementNameInputChange = formHeaderId => evt => {
    const value = evt.target;
    if (validFormHeaderIds.has(formHeaderId)) {
      validFormHeaderIds.delete(formHeaderId);

      const { propertyTypeId, supplementName } = supplements.find(supp => supp.formHeaderId === formHeaderId);
      const supplementNameIndex = getSupplementIndex(propertyTypeId, supplementName, formHeaderId);

      const updatedSupplementData = JSON.parse(JSON.stringify({ ...supplementData }));

      updatedSupplementData[propertyTypeId][supplementNameIndex] = {
        ...updatedSupplementData[propertyTypeId][supplementNameIndex],
        price: '',
      };

      setSupplementData(updatedSupplementData);
      setFilteredCategorySupplementData(updatedSupplementData);
      setFilteredSupplementData(updatedSupplementData);
    } else {
      validFormHeaderIds.add(formHeaderId);
    }
    if (value.value === '') {
      validFormHeaderIds.delete(formHeaderId);
    }
  };

  const getSupplementIndex = (propertyTypeId, supplementNameId, formHeaderId) =>
    supplementData[propertyTypeId][formHeaderId].findIndex(cat => cat.formHeaderId === formHeaderId);

  const getProductNameIndex = (propertyTypeId, productCategoryId, productId) =>
    columnData[propertyTypeId][productCategoryId].findIndex(cat => cat.productId === productId);

  const addSupplementToModifiedList = formHeaderId => {
    setValidFormHeaderIds(validFormHeaderIds.add(selectedFormHeaderId));
  };

  const handleProductNameCheckboxChange = productId => evt => {
    // toggle checked status
    if (validProductIds.has(productId)) {
      validProductIds.delete(productId);

      const { propertyTypeName, productCategoryName } = products.find(product => product.productId === productId);
      const productNameIndex = getProductNameIndex(propertyTypeName, productCategoryName, productId);

      const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));

      updatedColumnData[propertyTypeName][productCategoryName][productNameIndex] = {
        ...updatedColumnData[propertyTypeName][productCategoryName][productNameIndex],
        qaPayable: '',
        frPayable: '',
      };

      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
    } else {
      validProductIds.add(productId);
    }
    console.log(evt.target.checked);
  };

  const handleChangeSupplementOverride = (field, record) => evt => {
    const { value } = evt.target;

    const updatedColumnData = JSON.parse(JSON.stringify({ ...supplementData }));
    const supplementNameIndex = getSupplementIndex(
      selectedPropertyTypeId,
      selectedSupplementName,
      selectedFormHeaderId,
    );

    updatedColumnData[selectedPropertyTypeId][selectedFormHeaderId][supplementNameIndex][field] = value;

    console.log(field);

    if (record.hasOwnProperty('productId')) {
      if (!modifiedProducts.find(x => x === record.productId)) {
        setModifiedProducts(modifiedProducts => [...modifiedProducts, record.productId]);
      }
    } else if (record.hasOwnProperty('formHeaderId')) {
      if (!modifiedSupplements.find(x => x === record.formHeaderId)) {
        setModifiedSupplements(modifiedSupplements => [...modifiedSupplements, record.formHeaderId]);
      }
    }

    setSupplementData(updatedColumnData);
    setFilteredCategorySupplementData(updatedColumnData);
    setFilteredSupplementData(updatedColumnData);
    addSupplementToModifiedList(selectedFormHeaderId);
  };

  const handleChangeProductOverride = (field, record) => evt => {
    const { value } = evt.target;

    const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));

    // const productNameIndex = updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId].findIndex(
    //   cat => cat.productId === selectedProductId,
    // );
    const productNameIndex = getProductNameIndex(selectedPropertyTypeId, selectedProductCategoryId, selectedProductId);

    updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId][productNameIndex][field] = value;

    const errorSelection = updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId][productNameIndex];

    const qaPayable_Is_Valid = !!errorSelection.qaPayable;
    const frPayable_Is_Valid = !!errorSelection.frPayable;

    // first happy path : all values are filled in
    if (qaPayable_Is_Valid && frPayable_Is_Valid) {
      let catError = false;
      let typError = false;
      const ind = errorName.findIndex(x => x == selectedProductId);
      if (ind >= 0) {
        errorName.splice(ind, 1);
      }
      Object.entries(columnData[selectedPropertyTypeId][selectedProductCategoryId]).forEach(([key, value]) => {
        const { productId } = value;
        // allows the foreach loop to evaluate every instance of the categorie's prooduct IDs in the error Name list.
        // Returns true if it finds one.
        if (errorName.includes(productId.toString())) {
          catError = true;
        }
      });

      //default behavior if the error array contains no members of the sub to the Type.
      // meaning no instance of a sub- product ID was found
      if (catError == false) {
        const ind = errorCategory.findIndex(x => x == selectedProductCategoryId);
        if (ind >= 0) {
          errorCategory.splice(ind, 1);
        }
      }

      Object.entries(columnData[selectedPropertyTypeId]).forEach(([key, value]) => {
        if (errorCategory.includes(key)) {
          typError = true;
        }
      });
      if (typError == false) {
        const ind = errorType.findIndex(x => x == selectedPropertyTypeId);
        if (ind >= 0) {
          errorType.splice(ind, 1);
        }
      }

      if (!validProductIds.has(selectedProductId)) {
        validProductIds.add(selectedProductId);
      }

      //Update Column Data
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
      addProductToModifiedList(selectedProductId);

      //Validate Data and add Errors
      setErrorType(errorType);
      setErrorCategory(errorCategory);
      setErrorName(errorName);

      // add record to modified overrides

      if (record.hasOwnProperty('productId')) {
        if (!modifiedProducts.find(x => x === record.productId)) {
          setModifiedProducts(modifiedProducts => [...modifiedProducts, record.productId]);
        }
      } else if (record.hasOwnProperty('formHeaderId')) {
        setModifiedSupplements([...modifiedSupplements, record]);
      }

      return;
    }
    // second happy path : no values are filled in
    if (!qaPayable_Is_Valid && !frPayable_Is_Valid) {
      let catError = false;
      let typError = false;
      const ind = errorName.findIndex(x => x == selectedProductId);

      if (ind >= 0) {
        errorName.splice(ind, 1);
      }
      Object.entries(columnData[selectedPropertyTypeId][selectedProductCategoryId]).forEach(([key, value]) => {
        const { productId } = value;
        // allows the foreach loop to evaluate every instance of the categorie's prooduct IDs in the error Name list.
        // Returns true if it finds one.
        if (errorName.includes(productId.toString())) {
          catError = true;
        }
      });

      //default behavior if the error array contains no members of the sub to the Type.
      // meaning no instance of a sub- product ID was found
      if (catError == false) {
        const ind = errorCategory.findIndex(x => x == selectedProductCategoryId);
        if (ind >= 0) {
          errorCategory.splice(ind, 1);
        }
      }

      Object.entries(columnData[selectedPropertyTypeId]).forEach(([key, value]) => {
        if (errorCategory.includes(key)) {
          typError = true;
        }
      });
      if (typError == false) {
        const ind = errorType.findIndex(x => x == selectedPropertyTypeId);
        if (ind >= 0) {
          errorType.splice(ind, 1);
        }
      }

      if (!validProductIds.has(selectedProductId)) {
        validProductIds.add(selectedProductId);
      }

      //Update Column Data
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
      addProductToModifiedList(selectedProductId);

      //Validate Data and add Errors
      setErrorType(errorType);
      setErrorCategory(errorCategory);
      setErrorName(errorName);
      return;
    }
    if (!qaPayable_Is_Valid || !frPayable_Is_Valid) {
      if (!errorType.includes(selectedPropertyTypeId.toString())) {
        errorType.push(selectedPropertyTypeId.toString());
      }
      if (!errorCategory.includes(selectedProductCategoryId.toString())) {
        errorCategory.push(selectedProductCategoryId.toString());
      }

      if (!errorName.includes(selectedProductId.toString())) {
        errorName.push(selectedProductId.toString());
      }

      if (!validProductIds.has(selectedProductId)) {
        validProductIds.add(selectedProductId);
      }

      //Update Column Data
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
      addProductToModifiedList(selectedProductId);

      //Validate Data and add Errors
      setErrorType(errorType);
      setErrorCategory(errorCategory);
      setErrorName(errorName);
      return;
    }
  };

  /**
   * FILTERS
   * */
  const runSupplementFilter = event => {
    const suppFilter = document?.getElementById('suppNameFilter').value.toUpperCase() ?? '';

    const returnedData = Object.entries(supplementData)
      ?.map(([TypeKey, TypeValue]) => {
        TypeValue = Object.entries(TypeValue)
          ?.filter(([CategoryKey, CategoryValue]) => {
            console.log(CategoryValue);
            return CategoryValue[0].supplementName?.toUpperCase()?.includes(suppFilter);
          })
          ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
            accCategory[CategoryKey] = CategoryValue;
            return accCategory;
          }, {});
        return [TypeKey, TypeValue];
      })
      ?.reduce((accType, [TypeKey, TypeValue]) => {
        accType[TypeKey] = TypeValue;
        return accType;
      }, {});
    setFilteredCategorySupplementData(returnedData);
  };

  const runCategoriesFilter = event => {
    const prodNameFilter = document?.getElementById('productNameFilter').value.toUpperCase() ?? '';
    const prodCategoriesFilter = document?.getElementById('productCategoriesFilter').value.toUpperCase() ?? '';

    const returnedData = Object.entries(columnData)
      ?.map(([TypeKey, TypeValue]) => {
        TypeValue = Object.entries(TypeValue)
          ?.filter(([CategoryKey, CategoryValue]) => {
            //console.log(key);
            return CategoryKey?.toUpperCase()?.includes(prodCategoriesFilter);
          })
          ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
            accCategory[CategoryKey] = CategoryValue;
            return accCategory;
          }, {});
        return [TypeKey, TypeValue];
      })
      ?.reduce((accType, [TypeKey, TypeValue]) => {
        accType[TypeKey] = TypeValue;
        return accType;
      }, {});
    setFilteredCategoryColumnData(returnedData);
  };

  const runNameFilter = event => {
    const prodNameFilter = document?.getElementById('productNameFilter').value.toUpperCase() ?? '';

    const returnedData = Object.entries(columnData)
      ?.map(([TypeKey, TypeValue]) => {
        TypeValue = Object.entries(TypeValue)
          ?.map(([CategoryKey, CategoryValue]) => {
            CategoryValue = Object.entries(CategoryValue)
              ?.filter(([NameKey, NameValue]) => {
                const { productCode } = NameValue;
                return productCode?.toUpperCase()?.includes(prodNameFilter);
              })
              ?.reduce((accName, [NameKey, NameValue]) => {
                accName.push(NameValue);
                return accName;
              }, []);
            return [CategoryKey, CategoryValue];
          })
          ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
            accCategory[CategoryKey] = CategoryValue;
            return accCategory;
          }, {});
        return [TypeKey, TypeValue];
      })
      ?.reduce((accType, [TypeKey, TypeValue]) => {
        accType[TypeKey] = TypeValue;
        return accType;
      }, {});
    setFilteredNameColumnData(returnedData);
  };

  const renderProductNameCell = (product, index) => {
    const { productId, productName, productCode } = product;

    const isSelected = productId === selectedProductId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedProductId(productId);
    };

    const isCheckboxChecked = validProductIds.has(product.productId);

    return renderCell({
      title: productCode,
      subtitle: productName,
      isError: errorName.includes(productId.toString()),
      isSelected,
      columnDisabled,
      key: `product-${selectedPropertyTypeId}-${selectedProductCategoryId}-${productId}`,
      onClick,
      showCheckbox: true,
      checked: isCheckboxChecked,
      onCheckboxClick: handleProductNameCheckboxChange(product.productId),
    });
  };

  /**
   * FUNCTIONS: RENDERING
   */
  const renderCell = ({
    title,
    subtitle,
    isSelected,
    isError = false,
    count = null,
    columnDisabled,
    key,
    onClick,
    showCheckbox = false,
    checked,
    onCheckboxClick,
  }) => {
    return (
      <div
        key={key}
        className={cn(
          classes.columnTile,
          isSelected && classes.columnTileSelected,
          columnDisabled && classes.columnDisabled,
        )}
        onClick={onClick}
      >
        <div className={cn('row-between-center')}>
          {/* {showCheckbox && (
            <ColoredCheckbox
              //
              style={{ marginRight: 15 }}
              checked={checked}
              onClick={onCheckboxClick}
            />
          )} */}

          <section className={cn('col-center-start text-left')}>
            <div>{title}</div>
            {subtitle && <div style={{ fontSize: '0.8em', color: isSelected ? null : '#AAA' }}>{subtitle}</div>}
          </section>
        </div>

        <div>
          {isError == true && <Error style={{ color: 'red' }} />}
          <ChevronRight />
        </div>
      </div>
    );
  };

  const renderSupplementNameCell = props => {
    const isSelected = props?.supplementName === selectedSupplementName;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedSupplementName(props?.supplementName);
      setSelectedFormHeaderId(props?.formHeaderId);
    };

    return renderCell({
      title: props?.supplementName,
      columnDisabled,
      isSelected,
      key: `Supplement-type-${props?.formHeaderId}`,
      onClick,
    });
  };

  const renderPropertyTypeCell = (name, index) => {
    /** supplements don't have a propertytypename column so map the id to the corresponding name */
    let typeName = name;

    if (supplementView) {
      if (name == 1) {
        typeName = 'Residential';
      } else if (name == 2) {
        typeName = 'Commercial';
      }
    }

    const isSelected = typeName === selectedPropertyTypeId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedProductId(null);
      setSelectedProductCategoryId(null);
      setSelectedPropertyTypeId(name);

      // for supplements
      setSelectedFormHeaderId(null);
      setSelectedSupplementName(null);
    };

    return renderCell({
      title: typeName,
      isSelected,
      isError: errorType.includes(name),
      columnDisabled,
      key: `property-type-${name}`,
      onClick,
    });
  };

  const renderProductCategoryCell = (name, index) => {
    const isSelected = name === selectedProductCategoryId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedProductId(null);
      setSelectedProductCategoryId(name);
    };

    return renderCell({
      title: name,
      isError: errorCategory.includes(name),
      isSelected,
      columnDisabled,
      key: `product-category-${selectedPropertyTypeId}-${name}`,
      onClick,
    });
  };

  const renderOverridesColumn = () => {
    const columnDisabled = !formIsReady;

    return formInputs.map(({ field, label }) => {
      const value = columnData[selectedPropertyTypeId][selectedProductCategoryId].find(
        cat => cat.productId === selectedProductId,
      )?.[field];

      const record = columnData[selectedPropertyTypeId][selectedProductCategoryId].find(
        cat => cat.productId === selectedProductId,
      );

      return (
        <div
          className={cn('row-between-center', columnDisabled && classes.columnDisabled)}
          style={{ borderBottom: '1px solid #AAA', paddingBottom: 10, marginBottom: 10 }}
          key={`product-${selectedProductId}-${field}`}
        >
          <div
            className={cn('row-between-center flex-1')}
            style={{
              minHeight: INPUT_ROW_HEIGHT,
            }}
          >
            <div className={'flex-1 text-left'}>{label}</div>
            <input
              type={'number'}
              min={'0'}
              value={value}
              className={cn('flex-1', classes.input, classes.textInput)}
              style={{
                width: 50,
              }}
              onChange={handleChangeProductOverride(field, record)}
            />
          </div>
        </div>
      );
    });
  };

  const renderSupplementOverridesColumn = () => {
    const columnDisabled = !formIsReady;
    return supplementFormInput.map(({ field, label }) => {
      const value = supplementData[selectedPropertyTypeId][selectedFormHeaderId]?.find(
        cat => cat.formHeaderId === selectedFormHeaderId,
      )?.[field];

      const record = supplementData[selectedPropertyTypeId][selectedFormHeaderId].find(
        cat => cat.formHeaderId === selectedFormHeaderId,
      );

      return (
        <div
          className={cn('row-between-center', columnDisabled && classes.columnDisabled)}
          style={{ borderBottom: '1px solid #AAA', paddingBottom: 10, marginBottom: 10 }}
          key={`product-${selectedFormHeaderId}-${field}`}
        >
          <div
            className={cn('row-between-center flex-1')}
            style={{
              minHeight: INPUT_ROW_HEIGHT,
            }}
          >
            <div className={'flex-1 text-left'}>{label}</div>
            <input
              type={'number'}
              min={'0'}
              value={value}
              className={cn('flex-1', classes.input, classes.textInput)}
              style={{
                width: 50,
              }}
              onChange={handleChangeSupplementOverride(field, record)}
              onInput={handleSupplementNameInputChange(selectedFormHeaderId)}
            />
          </div>
        </div>
      );
    });
  };

  console.log(changes);

  /**
   * EFFECTS
   * */
  useEffect(() => {
    getProductsData();
    getSupplementsData();
  }, []);

  useEffect(() => {
    createColumnData();
    createSupplementData();
  }, [products, supplements]);

  useEffect(() => {
    console.log({ changes });
  }, [changes]);

  console.log({ filteredCategoryColumnData, filteredCategorySupplementData });

  return (
    <>
      <Grid item xs={12} className={classes.container}>
        <Card className={cn('flex-1', 'flex-column')}>
          <CardHeader
            className={classes.cardHeader}
            titleTypographyProps={{ className: classes.cardHeaderTitle }}
            title={
              <div className="row-between-center">
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveChangesButton}
                    disabled={
                      !formIsReady || errorType.length > 0 || modifiedProducts.length + modifiedSupplements.length < 1
                    }
                    className={cn('light-blue-background')}
                    style={{
                      marginRight: 10,
                      opacity:
                        !formIsReady || modifiedProducts.length + modifiedSupplements.length < 1 || errorType.length > 0
                          ? 0.65
                          : 1,
                    }}
                  >
                    {formIsSaving ? <CircularProgress color="#fff" size={18} /> : 'Save Changes'}
                  </Button>

                  {/* Price Overrides */}
                  {formIsLoading && <CircularProgress size={20} style={{ color: 'var(--jmi-blue)', marginLeft: 20 }} />}
                </div>
                <div className="flex-1 row-start-center">
                  <div className="flex-column">
                    <InfoTooltip title="Switches view from products to supplements">
                      <CardHeader
                        style={{ padding: 0 }}
                        titleTypographyProps={{ className: classes.cardHeaderTitle }}
                        title={
                          <div>
                            <FormControlLabel
                              label="Supplement View"
                              labelPlacement="start"
                              control={<ColoredCheckbox checked={supplementView} onChange={toggleSupplementView} />}
                            />
                          </div>
                        }
                      />
                    </InfoTooltip>
                  </div>
                </div>
              </div>
            }
          />
          {/* Card for the radio buttons/checkbox */}
          <CardContent
            className={classes.table}
            style={{
              pointerEvents: !formIsReady || formIsSaving ? 'none' : 'auto',
              opacity: formIsReady ? 1 : 0.5,
            }}
          >
            {/* first column - product types */}
            {!supplementView ? (
              <div className={cn(classes.tableColumn)}>
                <div className={classes.tableColumnHeader}>Property Types</div>
                <div className={classes.columnListContainer}>
                  {Object?.keys(filteredCategoryColumnData)?.map(renderPropertyTypeCell)}
                </div>
              </div>
            ) : (
              <div className={cn(classes.tableColumn)}>
                <div className={classes.tableColumnHeader}>Property Types</div>
                <div className={classes.columnListContainer}>
                  {Object.keys(filteredCategorySupplementData).map(renderPropertyTypeCell)}
                </div>
              </div>
            )}

            {/* second column - product categories */}
            {/** Does not get rendered for supplement view */}
            {!supplementView ? (
              <div
                className={cn(
                  classes.tableColumn,
                  //   selectedCategoryId === null && classes.columnDisabled
                )}
              >
                <div className={classes.tableColumnInputHeader}>
                  <input
                    className={classes.inputHeader}
                    onChange={runCategoriesFilter} //? this.value == null : setFilteredColumnData(columnData)
                    id="productCategoriesFilter"
                    type="text"
                    placeholder="Product Categories"
                    onFocus={e => (e.target.placeholder = '')}
                    onBlur={e => (e.target.placeholder = 'Product Categories')}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  Object?.keys(filteredCategoryColumnData[selectedPropertyTypeId])
                    ?.sort()
                    ?.map(renderProductCategoryCell)}
              </div>
            ) : (
              <div
                className={cn(
                  classes.tableColumn,
                  //   selectedCategoryId === null && classes.columnDisabled
                )}
              >
                <div className={classes.tableColumnInputHeader}>
                  <input
                    className={classes.inputHeader}
                    onChange={runSupplementFilter} //? this.value == null : setFilteredSupplementData(supplementData)
                    id="suppNameFilter" // will need a replacement for this and above
                    type="text"
                    placeholder="Supplement Names"
                    onFocus={e => (e.target.placeholder = '')}
                    onBlur={e => (e.target.placeholder = 'Supplement Names')}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  Object.values(filteredCategorySupplementData[selectedPropertyTypeId])
                    .map(x => x[0])
                    .sort()
                    ?.map(renderSupplementNameCell)}
              </div>
            )}

            {/* third column - product names */}
            {/** Does not get rendered for supplement view */}
            {/** Instead of renderering nothing for supplement view, render overrides */}
            {!supplementView ? (
              <div
                className={cn(
                  classes.tableColumn,
                  //   selectedCategoryId === null && classes.columnDisabled
                )}
                // rerenders the column so React doesn't cache previous products
              >
                <div className={classes.tableColumnInputHeader}>
                  <input
                    className={classes.inputHeader}
                    onChange={runNameFilter}
                    id="productNameFilter"
                    type="text"
                    placeholder="Product Names"
                    onFocus={e => (e.target.placeholder = '')}
                    onBlur={e => (e.target.placeholder = 'Product Names')}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  !!selectedProductCategoryId &&
                  filteredNameColumnData[selectedPropertyTypeId][selectedProductCategoryId]
                    ?.sort((a, b) => a.productCode.localeCompare(b.productCode))
                    ?.map(renderProductNameCell)}
              </div>
            ) : (
              <>
                {/** Overrides for supplement view */}
                <div className={cn(classes.tableColumn, classes.recommendationFormColumn)}>
                  <div className={cn(classes.tableColumnHeader, 'row-center-center')}>
                    <div className="flex-1">Payable Overrides</div>
                  </div>
                  <div className={classes.recommendationFormContainer}>
                    {!!selectedPropertyTypeId && !!selectedSupplementName && renderSupplementOverridesColumn()}
                  </div>
                  {/** this is the container */}
                </div>
              </>
            )}

            {/* fourth column - price overrides */}
            {!supplementView ? (
              <div className={cn(classes.tableColumn, classes.recommendationFormColumn)}>
                <div className={cn(classes.tableColumnHeader, 'row-center-center')}>
                  <div className="flex-1">Payable Overrides</div>
                </div>
                <div className={classes.recommendationFormContainer}>
                  {!!selectedPropertyTypeId &&
                    !!selectedProductCategoryId &&
                    !!selectedProductId &&
                    renderOverridesColumn()}
                </div>
              </div>
            ) : null}
          </CardContent>
        </Card>
      </Grid>
      <ConfirmationDialog
        minHeight={'50vh'}
        minWidth={'60vw'}
        maxWidth={'xl'}
        visible={showSaveChangesModal}
        setVisibility={setSaveChangesModal}
        title={'Confirm Changes'}
        cancelButton={
          <Button onClick={() => setSaveChangesModal(false)} style={{ backgroundColor: '#F44336', color: 'white' }}>
            Cancel
          </Button>
        }
        acceptButton={
          <Button
            onClick={saveOverridesAsync}
            disabled={formIsSaving}
            style={{
              backgroundColor: '#315382',
              color: 'white',
              opacity: formIsSaving ? 0.65 : 1,
            }}
          >
            Confirm Changes
          </Button>
        }
      >
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>QA Payable</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Field Rep Payable</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {changes.product?.map(row => (
                <TableRow>
                  <TableCell>
                    {row.productCode}
                    <div style={{ fontSize: '0.8em' }}>{row.productName}</div>
                  </TableCell>
                  <TableCell>{row.qaPayable ? '$' + row.qaPayable : ' '}</TableCell>
                  <TableCell>{row.frPayable ? '$' + row.frPayable : ' '}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Supplement</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>QA Payable</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Field Rep Payable</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {changes.supplement?.map(row => (
                <TableRow>
                  <TableCell>{row.supplementName}</TableCell>
                  <TableCell>{row.qaPayable ? '$' + row.qaPayable : ' '}</TableCell>
                  <TableCell>{row.frPayable ? '$' + row.frPayable : ' '}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ConfirmationDialog>
    </>
  );
};

FieldRepQAPrice.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(FieldRepQAPrice));
